// import placeholderData from "./placeholderData";

const loadContract = ({ sku, price }) =>
  fetch(
    `https://api.joinclyde.com/products/${sku}/contracts${price ? `?price=${price}` : ""
    }`,
    {
      headers: {
        Authorization: window.ClydeClientKey,
      },
    }
  ).then((res) => res.json());

// const loadContract = () => Promise.resolve({ data: placeholderData });

class AddProductProtection extends HTMLElement {
  static observedAttributes = ["warranty-id", "variant-id", "price", "quantity"];

  constructor() {
    super();
    this.removeEvents = [];
    this.requestId = 0;
    this.timeout = null;
  }

  get warrantyId() {
    return this.getAttribute("warranty-id");
  }

  get variantId() {
    return this.getAttribute("variant-id");
  }

  get price() {
    return this.getAttribute("price");
  }

  get productTitle() {
    return this.getAttribute("product-title");
  }

  get key() {
    return this.getAttribute("key");
  }

  get quantity() {
    return parseInt(this.getAttribute("quantity"), 10);
  }

  get termsLink() {
    return this.querySelector("[data-terms-link]");
  }

  get select() {
    return this.querySelector("[data-select]");
  }

  get cta() {
    return this.querySelector("[data-cta]");
  }

  get inner() {
    return this.querySelector("[data-inner]");
  }

  connectedCallback() {
    // rely on attributeChangedCallback to call _init
  }

  disconnectedCallback() {
    this.removeEvents.forEach((removeEvent) => removeEvent());
    this.removeEvents = [];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "quantity" && oldValue === "1" && newValue === "0") {
      this.style.display = "block";

      window.hideItemWithAnimation(this).then(() => {
        this.style.display = null;
      });

      return;
    }

    if (
      (name === "quantity" && oldValue === "0") ||
      (name !== "quantity" && oldValue !== newValue)
    ) {
      this.setAttribute("loading", "");
    }

    if (this.timeout) return;

    // Wait briefly in case multiple attrs change at once
    this.timeout = setTimeout(() => {
      this.timeout = null;
      this.disconnectedCallback();
      this._init();
    }, 100);
  }

  _init() {
    this.requestId++;
    const currentId = this.requestId;
    loadContract({ sku: this.variantId, price: this.price })
      .then(({ data }) => {
        if (currentId !== this.requestId || !data) return;

        this.select.innerHTML = data
          .map(
            (item) =>
              `<option value="${item.attributes.shopifyVariantId}">${item.attributes.termLabelPlural
              } Enhanced Protection for ${window.formatMoney(
                item.attributes.recommendedPrice
              )}</div>`
          )
          .join("");

        // Link is the same for all contracts so just grab first one
        // Skip updating terms link per VRE002R-313
        // this.termsLink.href = data[0].attributes.link;

        const handleAdd = () => {
          const items = [
            {
              id: this.select.value,
              quantity: this.quantity,
              properties: {
                Product: this.productTitle,
                _productItemKey: this.key,
                _productItemVariantId: this.warrantyId,
              },
            },
          ];

          window.addToCart(items);

          window.hideItemWithAnimation(this);
        };

        this.cta.addEventListener("click", handleAdd);
        this.removeEvents.push(() =>
          this.cta.removeEventListener("click", handleAdd)
        );

        if (this.hasAttribute("loading")) {
          this.removeAttribute("loading");

          if (this.quantity > 0) {
            window.requestAnimationFrame(() => {
              window.showItemWithAnimation(this);
            });
          }
        }
      })
      .catch((error) => {
        console.log("Error getting contract", error);
      });
  }
}

if (!customElements.get("add-product-protection")) {
  customElements.define("add-product-protection", AddProductProtection);
}
